module.exports = __webpack_public_path__ + "static/scale-model-of-group-destination-planners-llc-in-billings-montana-72fd14ffd5def817f7da081d78450236.png";